import { render } from "./SelectedBox.vue?vue&type=template&id=0f5b0082&scoped=true"
import script from "./SelectedBox.vue?vue&type=script&lang=js"
export * from "./SelectedBox.vue?vue&type=script&lang=js"

import "./SelectedBox.vue?vue&type=style&index=0&id=0f5b0082&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f5b0082"]])

export default __exports__